<style lang="less" scoped>
//设置整个table样式
/deep/.el-table{background: none !important;}
//修改表格头部样式
/deep/.el-table tr {background: none !important; }
/deep/.el-table tr .is-center{background: none !important; color: #fff; border: none;}
/deep/.is-group>tr{background: none !important;}
//修改分页菜单yangs
/deep/.el-pager li{background: transparent !important; color: #fff;}
/deep/.el-pager > .active{background: transparent !important; color: #23fffc;}
/deep/.btn-prev{background: transparent !important;color: #fff !important;}
/deep/.btn-next{background: transparent !important;color: #fff !important;}
/deep/.el-table__row--striped td{background: none !important;}
/deep/.el-table__body tr:hover>td{background: none !important;}
/deep/.el-table__header th {padding: 0;height: 30px;}
/deep/.el-table__body td {padding: 0;height: 30px;color: #fff;}
</style>

<template>
  <el-table
    :header-cell-style="headercell" :row-style='rowstyles'
    stripe
    :data="tableData"
    height="180"
    style="width: 100%;background:none;">
    <el-table-column align="center" prop="name" label="资源储量类别" width="180"></el-table-column>
    <el-table-column label="矿石量" align="center"></el-table-column>
    <el-table-column align="center" prop="mineral" width="160" label="万(t)"></el-table-column>
    <el-table-column label="金属量" align="center"></el-table-column>
    <el-table-column align="center" prop="sn" label="Sn" width="150"></el-table-column>
    <el-table-column align="center" prop="zn" label="Zn" width="150"></el-table-column>
    <el-table-column align="center" prop="cu" label="Cu" width="150"></el-table-column>
    <el-table-column align="center" prop="ag" label="Ag" width="150"></el-table-column>
  </el-table>
</template>

<script>
export default {
  data()
  {
    return {
      tableData: []
    }
  },
  mounted()
  {
    this.$nextTick(() =>
    {
      this.getModAttbue()
    })
  },
  methods:
  {
    getModAttbue()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 103, _exp: 'id > 0'}
      window.post.getPost(paras).then((ret) =>
      {
        this.tableData = ret
      })
    },
    //表头样式设置
    headercell(row, column, rowIndex, columnIndex)
    {
      return 'background: rgba(35, 134, 135, 0.7) !important;color: #23fffc;'
    },
    //修改表格行样式
    rowstyles({row, rowIndex})
    {
      if (rowIndex % 2 === 1)
      {
        let styleJson = {
          'background': 'rgba(2,36,38, .8) !important'
        }
        return styleJson
      }
      else
      {
        let styleJson = {
          'background': 'rgba(44,74,73, .8) !important'
        }
        return styleJson
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/ModeAttbute.vue